/*
 * Inka — selector Recogida / Delivery (agente C).
 * - Varias instancias (<inka-modo>) en la página: se mantienen sincronizadas.
 * - Guarda en el atributo del carrito `modo_pedido` (POST /cart/update.js) y en localStorage ('inka:modo').
 * - Emite en document: CustomEvent('inka:modo-change', { detail: { modo, label, tiempo } }).
 * - API: window.InkaModo.get() -> 'recogida' | 'delivery' ; window.InkaModo.set('delivery').
 * - Atributo <html data-inka-modo="recogida|delivery"> para estilos.
 */
(() => {
  if (window.InkaModo) return;

  const KEY = 'inka:modo';
  const VALID = ['recogida', 'delivery'];
  let current = null;
  let pending = null;

  const readLocal = () => {
    try {
      const v = window.localStorage.getItem(KEY);
      return VALID.includes(v) ? v : null;
    } catch (_) {
      return null;
    }
  };
  const writeLocal = (v) => {
    try {
      window.localStorage.setItem(KEY, v);
    } catch (_) {
      /* modo privado o almacenamiento bloqueado */
    }
  };

  const cartRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const saveToCart = (modo) => {
    if (pending) pending.abort();
    pending = new AbortController();
    return fetch(`${cartRoot()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { modo_pedido: modo } }),
      signal: pending.signal,
    }).catch(() => {
      /* sin red o abortado: queda en localStorage y se reintenta en la siguiente carga */
    });
  };

  const infoFor = (modo) => {
    const input = document.querySelector(`inka-modo input[value="${modo}"]`);
    return {
      modo,
      label: input ? input.dataset.label : modo,
      tiempo: input ? input.dataset.tiempo : '',
    };
  };

  const paint = (modo) => {
    document.querySelectorAll('inka-modo input.inka-modo__input').forEach((input) => {
      input.checked = input.value === modo;
    });
    document.documentElement.dataset.inkaModo = modo;
  };

  const set = (modo, { persist = true, emit = true } = {}) => {
    if (!VALID.includes(modo)) return;
    const changed = modo !== current;
    current = modo;
    paint(modo);
    writeLocal(modo);
    if (persist) saveToCart(modo);
    if (emit && changed) {
      document.dispatchEvent(new CustomEvent('inka:modo-change', { detail: infoFor(modo) }));
    }
  };

  class InkaModoElement extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = event.target;
        if (target instanceof HTMLInputElement && target.classList.contains('inka-modo__input')) {
          set(target.value);
        }
      });
      if (current) paint(current);
    }
  }

  const init = () => {
    const el = document.querySelector('inka-modo');
    const cartModo = el && VALID.includes(el.dataset.cartModo) ? el.dataset.cartModo : null;
    const local = readLocal();
    const fallback = el && VALID.includes(el.dataset.default) ? el.dataset.default : 'recogida';

    if (cartModo) {
      // El carrito manda (es lo que llega al pedido).
      set(cartModo, { persist: false, emit: false });
    } else if (local) {
      // Elegido antes en este navegador pero el carrito es nuevo: se sincroniza una vez.
      set(local, { persist: true, emit: false });
    } else {
      // Nadie ha elegido: se muestra el por defecto y NO se escribe en el carrito hasta que el cliente toque.
      current = fallback;
      paint(fallback);
    }
  };

  window.InkaModo = {
    get: () => current,
    set: (modo) => set(modo),
  };

  if (!customElements.get('inka-modo')) customElements.define('inka-modo', InkaModoElement);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
